import PendingInvitationBannerV2 from "./PendingInvitationBannerV2";
export default PendingInvitationBannerV2;
